import Api from "../../apiService";

class TelemetryPositionsApi {
  positionsWithRawData(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/positions/with_raw_data`,
      params,
      Api.authHeaders()
    );
  }

  markAsExcluded(companyId, positionId) {
    return Api.patchRequest(
      `companies/${companyId}/telemetry/positions/${positionId}/mark_as_excluded`,
      {},
      Api.authHeaders()
    );
  }

  markAsIncluded(companyId, positionId) {
    return Api.patchRequest(
      `companies/${companyId}/telemetry/positions/${positionId}/mark_as_included`,
      {},
      Api.authHeaders()
    );
  }

  // Массово меняет участие точек в расчёте маршрута
  massUpdateExclusion(companyId, positionIds, action) {
    return Api.patchRequest(
      `companies/${companyId}/telemetry/positions/mass_update_exclusion`,
      { position_ids: positionIds, exclusion_action: action },
      Api.authHeaders()
    );
  }
}

export default new TelemetryPositionsApi();
